<template>
  <div>
    <h2>Actions</h2>

    <v-card outlined class="mb-4 pa-2">
      <v-switch
        v-model="kioskMode"
        label="Simulate Kiosk Mode"
        hint="Forces the app to behave as if it's on a physical kiosk"
        persistent-hint
        color="primary"
        inset
      ></v-switch>
    </v-card>

    <router-link :to="{ name: 'Change-Password' }">Change Password</router-link>
    <v-spacer />
    <router-link :to="{ name: 'Admin-Categories' }"
      >Update Categories</router-link
    >
    <v-spacer />
    <router-link :to="{ name: 'Admin-Listings' }">Update Listings</router-link>
    <v-spacer />
    <router-link :to="{ name: 'Admin-Services' }"
      >Update Services and Tags</router-link
    >
    <v-spacer />
    <router-link :to="{ name: 'Admin-Sponsors' }"
      >Update Sponsor Data</router-link
    >
    <v-spacer />
    <router-link :to="{ name: 'Admin-Searches' }"
      >View User Search Statistics</router-link
    >
    <v-spacer />
    <router-link :to="{ name: 'Admin-Dead-Links' }"
      >Check for Dead Links</router-link
    >
    <v-spacer />
    <router-link :to="{ name: 'Admin-Link-Clicks' }"
      >View Link Click Statistics</router-link
    >
    <v-spacer />
    <router-link :to="{ name: 'Admin-Pending-Listings' }"
      >Review Pending Listings</router-link
    >
    <span v-if="pendingListingCount > 0" class="pending-badge">{{
      pendingListingCount
    }}</span>
    <v-spacer />
    <router-link :to="{ name: 'Admin-Providers' }"
      >Review Provider Requests</router-link
    >
    <span v-if="pendingProviderCount > 0" class="pending-badge">{{
      pendingProviderCount
    }}</span>

    <v-divider class="my-4" />

    <h2 class="mb-3">Notification Settings</h2>
    <v-card outlined class="pa-3">
      <p class="body-2 grey--text mb-3">
        Weekly digest emails about pending provider requests and listings
        (waiting &gt;5 days) will be sent to this address. Leave blank to use
        the server default (<code>fmakiosk@gmail.com</code>).
      </p>
      <v-form @submit.prevent="saveSettings">
        <v-text-field
          v-model="notificationEmail"
          label="Notification email address"
          outlined
          type="email"
          :loading="settingsLoading"
          :disabled="settingsLoading || settingsLoadFailed"
        />
        <v-alert v-if="settingsError" type="error" class="mb-2">{{
          settingsError
        }}</v-alert>
        <v-alert v-if="settingsSaved" type="success" class="mb-2"
          >Settings saved.</v-alert
        >
        <v-btn
          depressed
          color="secondary"
          class="white--text"
          type="submit"
          :loading="settingsLoading"
          :disabled="settingsLoadFailed"
        >
          Save
        </v-btn>
        <v-btn v-if="settingsLoadFailed" flat @click="loadSettings">
          Retry
        </v-btn>
      </v-form>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      notificationEmail: "",
      settingsLoading: false,
      settingsSaved: false,
      settingsError: "",
      settingsLoadFailed: false
    };
  },
  computed: {
    kioskMode: {
      get() {
        return this.$store.state.kioskMode;
      },
      set(v) {
        this.$store.commit("assignKioskMode", v);
      }
    },
    pendingListingCount() {
      return this.$store.state.pendingListingCount || 0;
    },
    pendingProviderCount() {
      return this.$store.state.pendingProviderCount || 0;
    }
  },
  async mounted() {
    this.$store.dispatch("fetchPendingListings").catch(() => {});
    this.$store.dispatch("fetchProviders").catch(() => {});
    await this.loadSettings();
  },
  methods: {
    async loadSettings() {
      this.settingsLoading = true;
      this.settingsError = "";
      this.settingsLoadFailed = false;
      try {
        const settings = await this.$store.dispatch("fetchAdminSettings");
        this.notificationEmail =
          (settings && settings.notification_email) || "";
      } catch {
        this.settingsLoadFailed = true;
        this.settingsError =
          "Could not load current settings. Fix your connection and retry before saving — saving now could clear a previously configured address.";
      } finally {
        this.settingsLoading = false;
      }
    },
    async saveSettings() {
      this.settingsError = "";
      this.settingsSaved = false;
      this.settingsLoading = true;
      try {
        await this.$store.dispatch("updateAdminSettings", {
          notification_email: this.notificationEmail
        });
        this.settingsSaved = true;
        setTimeout(() => {
          this.settingsSaved = false;
        }, 3000);
      } catch (err) {
        this.settingsError = err.message || "Failed to save settings.";
      } finally {
        this.settingsLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.pending-badge {
  display: inline-block;
  min-width: 16px;
  height: 16px;
  line-height: 16px;
  padding: 0 4px;
  border-radius: 8px;
  background-color: #ff5252;
  color: #ffffff;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
  margin-left: 4px;
}
</style>
